import { SAVE_TRADE_FEED_SOURCE } from '../../util/actionTypes';

const initialState = { source: null };

const tradeFeedSourceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_TRADE_FEED_SOURCE:
            return {
                ...state,
                source: action.payload
            };
        default:
            return state;
    }
};

export default tradeFeedSourceReducer;


